import { Button } from '@vallourec-ui/vallourec-ui'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  height: 2rem;

  .notification-dot {
    top: 0;
    right: 0;
    width: 0.5rem;
    height: 0.5rem;
    background-color: red;
    border-radius: 50%;
    border: 2px solid white;
  }
`
export const StyledRightIcon = styled.div`
  margin-left: auto;
`

export const MenuItem = styled.div`
  cursor: pointer;
  flex-direction: row;
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: flex-start;
  gap: 5px;
`

export const Divider = styled.div`
  font-size: 0.6rem;
  border-bottom: 0.05rem solid #e8e8e8;
  border-bottom-color: #e8e8e8;
  border-bottom-width: 0.05rem;
  margin: 0.3rem 0;
`

export const NotificationBellContainer = styled.div`
  position: relative;
  display: inline-block;
`

export const BellIcon = styled.i`
  font-size: 24px;
  cursor: pointer;
`

export const NotificationList = styled.ul`
  position: absolute;
  right: 0;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 10px;
  margin: 0 3rem 0rem 0rem;
  z-index: 1000;
`

export const NotificationItem = styled.li`
  padding: 5px 10px;
  border-bottom: 1px solid #eee;

  &:last-child {
    border-bottom: none;
  }
`

export const ContainerIcon = styled.div`
  height: 2rem;
`
